<template>
	<div class="stop-selector">
		<ul class="stop-selector__list" :class="{'stop-selector__list--selected':fromStopIndex !== null || toStopIndex !== null}">
			<li
				v-for="(stop, index) in stops"
				:key="index"
				class="stop-selector__item"
				:class="{'stop-selector__item--from': fromStopIndex === index, 'stop-selector__item--to': toStopIndex === index, 'request-only': stop.isDemandDriven}"
				@click.stop.prevent="selectStop(stop, index)"
			>{{stop.stopName}}<inline-svg class="demand-driven-icon" v-if="stop.specialSign == 'a'" style="float:right; margin-right:10px; width:20px; height: 20px;" :src="require('@/assets/icons/a-pikto.svg')"></inline-svg></li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "RouteStopSelector",
	props: {
		stops: {
			type: Array,
			require: true,
		},
		fromStopIndex: {
			type: [String, Number],
			require: true,
		},
		toStopIndex: {
			type: [String, Number],
			require: true,
        },
        single: {
            type: Boolean,
            default: false
        },
        singleType: {
            type: String
        }
	},
	data() {
		return {};
	},
	methods: {
		selectStop: function (stop, index) {
            if(typeof this.single !== "undefined" && this.single && this.singleType)
            this.$emit("selectStop", { stop: stop, index: index, type: this.singleType });
            else
            this.$emit("selectStop", { stop: stop, index: index });
		},
	},
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/__variables.scss";

.stop-selector {
	padding: 15px 0;
}

.stop-selector__list {
	margin: 0;
	padding: 0;
	position: relative;
}

.stop-selector__item {
	padding-left: 40px;
	line-height: 18px;
	position: relative;
	display: block;
	list-style-type: none;
	font-size: 1rem;
    color: $dark;
    cursor: pointer;

	&:not(:first-of-type) {
		padding-top: 27px;
	}

	&::before {
		content: "";
		width: 6px;
		background-color: $blue;
        border-left:1px solid $blue;
        border-right:1px solid $blue;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 17px;
	}

	&::after {
		content: "";
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background-color: white;
		border: 2px solid $blue;
		position: absolute;
        z-index: 1;
		top: 27px;
		left: 20px;
		transform: translateX(-50%);
	}

    &:first-of-type,
	&:last-of-type {
		font-weight: 700;
	}

    &:first-of-type {
        &::after {
            top:-0;
        }
    }
    
    &.request-only {
        &::before {
            background-color:white;
        }

        + .stop-selector__item {
            &::before {
                background-color:white;
            }
        }
    }
}

.stop-selector__list--selected {
	.stop-selector__item {
		color: $grey3;

		&::before {
			background-color: $grey3;
            border-color:$grey3;
		}

		&::after {
			border-color: $grey3;
		}

        &.request-only {
            &::before {
                background-color:white;
            }

            + .stop-selector__item {
                &::before {
                    background-color:white;
                }
            }
        }
    }
    
    .stop-selector__item.stop-selector__item--from {
        color: $dark;

        &::before {
            background-color: $grey3;
            border-color:$grey3;
        }

        &.request-only {
            &::before {
                background-color:white;
            }

            + .stop-selector__item {
                &::before {
                    background-color:white;
                }
            }
        }

        &::after {
            border-color: $blue;
            border:0;
            width:24px;
            height:24px;
            line-height: 24px;
            text-align: center;
            background-color:$grey2;
            color:white;
            font-weight: 700;
            font-size: 16px;
            content:'A';
            transform: translate(-50%, -2px);
        }
        & ~ .stop-selector__item:not(.stop-selector__item--to) {
            color: $dark;

            &::before {
                background-color: $blue;
            }

            &.request-only {
                &::before {
                    background-color:white;
                    border-color:$blue;
                }

                + .stop-selector__item {
                    &::before {
                        background-color:white;
                        border-color:$blue;
                    }
                }
            }

            &::after {
                border-color: $blue;
            }
        }
        
        & ~ .stop-selector__item--to {
            color: $dark;

            &::before {
                background-color: $blue;
                border-color:$blue;
            }
            &.request-only {
                &::before {
                    background-color:white;
                }

                + .stop-selector__item {
                    &::before {
                        background-color:white;
                    }
                }
            }
            &::after {
                border-color: $blue;
                border:0;
                width:24px;
                height:24px;
                line-height: 24px;
                text-align: center;
                background-color:$green;
                color:white;
                font-weight: 700;
                font-size: 16px;
                content:'B';
                transform: translate(-50%, -2px);
            }
            & ~ .stop-selector__item {
                color: $grey3;

                &::before {
                    background-color: $grey3;
                    border-color:$grey3;
                }
                &.request-only {
                    &::before {
                        background-color:white;
                        border-color:$grey3;
                    }

                    + .stop-selector__item {
                        &::before {
                            background-color:white;
                            border-color:$grey3;
                        }
                    }
                }

                &::after {
                    border-color: $grey3;
                }
            }
        }

        & + .stop-selector__item:last-of-type:not(.request-only) {
            &::before {
                background-color:white!important;
                border-color:$blue;
            }
        }
    }
}
</style>
